import script from "./RuleButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleButtons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__